import { useEffect, useState } from 'react'

import { List, ListItem, ListItemText } from '@mui/material'
import { ConsoleDialog } from '@/components/ConsoleDialog'
import {
  ListDialogContext,
  ListDialogOptions,
  useListDialogStore
} from '@/contexts/ListDialogContext'

type ListDialogProviderProps = {
  children: React.ReactNode
}

export const ListDialogProvider = ({ children }: ListDialogProviderProps) => {
  const [options, setOptions] = useState<ListDialogOptions | null>(null)
  const [open, setOpen] = useState(false)

  const show = (newOptions: ListDialogOptions) => {
    setOptions(newOptions)
    setOpen(true)
  }

  useEffect(() => {
    useListDialogStore.show = show
  }, [])

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <ListDialogContext.Provider value={{ show }}>
      {children}
      {options && (
        <ConsoleDialog open={open} onClose={handleClose} title={options.title}>
          <List
            sx={{
              maxHeight: '300px',
              overflow: 'auto',
              mt: 2,
              border: (theme) => `1px solid ${theme.palette.divider}`,
              borderRadius: 1,
              '& > li:first-of-type': { pt: 0 },
              '& > li:last-of-type': { pb: 0 }
            }}
          >
            {options.items.map((item: string, index: number) => (
              <ListItem key={index} divider={index < options.items.length - 1}>
                <ListItemText primary={item} />
              </ListItem>
            ))}
          </List>
        </ConsoleDialog>
      )}
    </ListDialogContext.Provider>
  )
}
